<!-- <ion-header>
    <ion-toolbar>
        <ion-title>{{date | date: 'dd MMMM yyyy'}}</ion-title>
        <ion-buttons slot="end" (click)="closeModal()">
            <ion-icon name="close" size="large"></ion-icon>
        </ion-buttons>
    </ion-toolbar>
</ion-header> -->
<ion-card class="headmodal">
  <span class="titlemodal">
    {{date | date: 'dd MMMM yyyy'}}
  </span>
  <ion-button class="close-button" (click)="closeModal()">
      <ion-icon color="dark" name="close-outline"></ion-icon>
      
  </ion-button>
          <!-- <app-button class="close-button" [iconSrc]="'../../../assets/svg/close.svg'" (buttonClick)="closeModal()" color="primary"> -->
<!-- </app-button> -->
</ion-card >
<ion-card class="contentcard bg-light">
    <ng-container *ngIf="!loader;else loadSkeleton">
        <ng-container *ngIf="!emptyObject(this.menuData);else noFoodBooked">
            <ion-list lines="none" *ngIf="selectedFood.length > 0;else noFoodBooked">
            
                <ion-card *ngFor="let item of selectedFood" class="grid__item selected-food">
                    <ion-card class="innercard">
                        <div class="action-slot" >
                            <ion-chip class="mainchip">
                            <ng-container
                            *ngIf="item.food_type_category === 'meal';else snackMenu">
                            <ion-note>{{"meals" | translate}}</ion-note>
                            &nbsp;
                            </ng-container>
                            
                            <ng-template #snackMenu>
                            <ion-note>{{"snacks" | translate}}</ion-note>
                            &nbsp;
                            </ng-template>
                            </ion-chip>
                        </div>
                    <div class="imgcontainer">
                        <ion-thumbnail class="imgwrapper"  >
                          <ng-container *ngIf="item.attachment;else dummyImage">
                            <ion-img
                              class="menu-image"
                              [src]="item.attachment"></ion-img>
                          </ng-container>
                          <ng-template #dummyImage>
                            <ion-img
                              class="menu-image"
                              src="../../assets/dummy.png"></ion-img>
                          </ng-template>
                        </ion-thumbnail>
                    </div>
                    <div class="bottom">
                    <div class="content"  >
                        <ion-label class="menuname">
                                <ng-container *ngIf="settings?.appLanguage === 'ar';else engTtile">
                                  {{item.a_name}}
                                </ng-container>
                                <ng-template #engTtile> {{item.name}} </ng-template>
                            </ion-label>
                          </div>
                          
                          <div class="ratingBox">
                     <main-rating
        [(ngModel)]="item.my_rating"
        [readOnly]="false"
        [max]="5"
        emptyStarIconName="star-outline"
        starIconName="star"
        halfStarIconName="star-half"
        (valueChange)="onRatingChange(item, $event)"
      ></main-rating>
      <div *ngIf="item.comment" class="comment">
                          {{item.comment}}
                    </div>
                </div>
                         <macros-bar [item]="item" color="primary"></macros-bar>
                      </div>
                    </ion-card> 
                </ion-card>
    
            </ion-list>
        </ng-container>
        <ng-template #noFoodBooked>
            <ion-card class="openclear">
                <p>
                    <ion-icon name="alert-circle-outline" color="secondary"></ion-icon>
                </p>
                <ion-label color="dark">{{"no_food_order_find_in_this_date" | translate }}</ion-label>
            </ion-card>
        </ng-template>
    </ng-container>
    <ng-template #loadSkeleton>
        <div class="typing-indicator">
			<div class="typing-circle"></div>
			<div class="typing-circle"></div>
			<div class="typing-circle"></div>
			<div class="typing-shadow"></div>
			<div class="typing-shadow"></div>
			<div class="typing-shadow"></div>
		</div>
    </ng-template>
</ion-card>